// extracted by mini-css-extract-plugin
module.exports = {"intro":"HipHipGoDescription_intro__1sRe-","icon":"HipHipGoDescription_icon__2ZWjj","content":"HipHipGoDescription_content__iIDhA","demo":"HipHipGoDescription_demo__3cTn3"};